module.exports = __webpack_public_path__ + "img/face.446c213d.png";